<template>
  <div
    v-if="parsedDetailConfig.shouldShow"
    class="parsed-detail-item d-flex flex-row"
  >
    <!-- new style for document view left panel -->
    <data-block
      :label="parsedDetailConfig.title"
      :left-icon="parsedDetailConfig.icon"
      :value="getParsedValue(parsedDetailConfig)"
      :has-copy-text="true"
      :right-icon="rightIcon"
      @onRightIconClick="onRightIconClick"
    >
    </data-block>
  </div>
</template>

<script>
import * as parsedDetailsTypes from '../../constants/parsedDetailsTypes';
import parsedDetailsConfig from '../../constants/parsedDetailsConfig';
import { sanitizeUrl } from '@braintree/sanitize-url';
import DataBlock from '@/V2/components/DataBlock';

const defaultConfig = {
  multi: false,
  show: () => true,
  format: ({ formatted }) => formatted,
};

export default {
  components: {
    DataBlock,
  },
  props: {
    hideLabel: {
      type: Boolean,
      default: false,
    },
    parsedDetailsType: {
      type: String,
      required: true,
    },
    parsedDetail: {
      type: [Object, Array],
      required: true,
    },
    rightIcon: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      parsedDetailsTypes,
      parsedDetailsConfig,
      sanitizedOpenCorporatesUrl: sanitizeUrl(
        this.parsedDetail.opencorporates_url,
      ),
      sanitizedRegistryUrl: sanitizeUrl(this.parsedDetail.registry_url),
    };
  },
  computed: {
    parsedDetailConfig() {
      const config = {
        ...defaultConfig,
        ...parsedDetailsConfig[this.parsedDetailsType],
      };
      return {
        ...config,
        value: this.parsedDetail,
        shouldShow: config.show(this.parsedDetail),
      };
    },
  },
  methods: {
    getParsedValue(parsedDetailConfig) {
      const texts = parsedDetailConfig.multi
        ? parsedDetailConfig.value
        : [parsedDetailConfig.value];
      return texts.map((txt) => parsedDetailConfig.format(txt)).join(', ');
    },
    onRightIconClick() {
      this.$emit('onRightIconClick');
    },
  },
};
</script>

<style lang="scss">
.parsed-detail-item {
  label {
    color: $light-neutral-110;
    font-size: $font-size-small;
    font-weight: 400;
  }

  .no-label {
    .icon-stat-icon {
      margin-top: 0px !important;
    }
  }

  .parsed-detail-value {
    font-size: $font-size-secondary;
    margin-top: -2px;

    span {
      line-height: 16px;
    }
  }

  .company-status {
    margin-top: -2px;
    font-size: $font-size-small;
  }
}

.company-popover-body {
  min-width: 200px;

  label {
    margin-top: 4px;
    font-size: $font-size-small;
  }
}
</style>
